// extracted by mini-css-extract-plugin
export var grayCircle = "_dr-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dr-1";
export var selectedCircle = "_dr-2";
export var shippingOptionImage = "_dr-3";
export var shippingOptionWidgetPreview = "_dr-4";